import { Box } from '@mui/material';
import React, { FC } from 'react';
import { TitleStyled } from '../styled';

interface TabPanelProps {
    children: any
    value: string,
    index: string
    title: string
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index, title }) => (
    <div
        aria-labelledby={`create-indicator-${index}`}
        hidden={value !== index}
        role="tabpanel"
    >
        {value === index && (
            <Box>
                <TitleStyled>{title}</TitleStyled>
                {children}
            </Box>
        )}
    </div>
);

export default TabPanel;
